import { jsxs as d, jsx as r } from "@emotion/react/jsx-runtime";
import { useRef as u } from "react";
import { ChipContainer as x, StyledIcon as c, ChipItemContainer as b, ChipItem as g, ChipText as I } from "./Chip.styled.js";
import { Icon as f } from "../Icon/index.js";
import { useChipKeyboardEvent as S } from "./hooks/useChipKeyboardEvent.js";
import { FontAwesomeIconsPartooUsed as k, IconPrefix as y } from "../../types/components/icon.js";
const E = ({
  dataTrackId: h,
  children: s,
  onClick: t,
  onIconAction: e,
  iconAction: i = [k.faCircleXmark, y.SOLID],
  chipShape: C = "rounded",
  disabled: l = !1,
  iconPosition: p = "right",
  variant: o = "primary"
}) => {
  const a = u(null), m = (n) => {
    n.stopPropagation(), e && !l && e(n);
  };
  return S({
    ref: a,
    onClick: t,
    onIconAction: e,
    disabled: l
  }), /* @__PURE__ */ d(x, { "data-track": h, disabled: l, variant: o, chipShape: C, isClickable: !!t, onClick: t, tabIndex: 0, ref: a, children: [
    e && p === "left" ? /* @__PURE__ */ r(c, { role: "button", onClick: m, "aria-label": "Close tag", children: /* @__PURE__ */ r(f, { color: o, icon: i, iconSize: "12px" }) }) : null,
    /* @__PURE__ */ r(b, { children: /* @__PURE__ */ r(g, { variant: o, "aria-disabled": l, children: /* @__PURE__ */ r(I, { variant: "bodySBold", color: o, children: s }) }) }),
    e && p === "right" ? /* @__PURE__ */ r(c, { role: "button", onClick: m, "aria-label": "Close tag", children: /* @__PURE__ */ r(f, { color: o, icon: i, iconSize: "12px" }) }) : null
  ] });
};
export {
  E as Chip
};
